<template>
  <div class="my-courses-page">
    <h1>My Requests</h1>
    <div class="content">
      <aside class="sidebar">
        <ul>
          <router-link :to="'/my-profile'"><li>My profile</li></router-link>
          <router-link :to="'/my-courses'"><li>Online Tutorials</li></router-link>
          <router-link :to="'/live-courses'"><li>Live courses</li></router-link>
          <router-link :to="'/my-requests'"
            ><li class="active">My requests</li></router-link
          >
        </ul>
      </aside>
      <div class="course-table" v-if="!load || requests.length">
        <table v-if="requests.length">
          <thead>
            <tr>
              <th>PRODUCT</th>
              <th>TOTAL</th>
              <th>STATUS</th>
              <th>DATE</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in requests" :key="data.id">
              <td>{{ data.course_name }}</td>
              <td>{{ data.course_price }} Azadi Coin (AC)</td>
              <td>{{ data.status }}</td>
              <td>{{ data.start_date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="course-list-place" v-else>
        <h2>
         You do not have any requests.
         </h2>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      requests: [],
      load: false,
    };
  },
  mounted() {
    this.getRequest();
  },
  methods: {
    toggleModule(index) {
      this.activeModule = this.activeModule === index ? null : index;
    },
    async getRequest() {
      try {
        this.load = false;
        const response = await axios.get("user/enrollment/request");
        this.requests = response.data.data;
        this.load = true;
      } catch (err) {
        this.load = true;
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
/* General Styling */
a {
  color: #fff;
  text-decoration: none;
}
.link {
  text-decoration: underline;
}
.my-courses-page {
  font-family: 'Gothic';
  margin: 0 auto 2rem;
  text-align: left;
}
.my-courses-page h1 {
  text-align: center;
  font-family: 'GothicB';
  padding: 3rem 0;
  background-color: #0e1332;
  color: #fff;
  font-size: 1.5rem;
}
.content {
  margin-top: 2rem;
  display: flex;
  gap: 2rem;
}

/* Sidebar */
.sidebar {
  flex: 1;
}
.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sidebar ul li {
  padding: 0.75rem 1rem 0.75rem 4rem;
  cursor: pointer;
  font-size: 1rem;
}
.sidebar ul li.active {
  color: orange;
  font-weight: bold;
}

.course-table {
  margin: 0 2rem;
  overflow: hidden;
  flex: 4;
  overflow: auto;
}

.course-table table {
  width: 100%;
  border: 1px solid #ccc;
  border-collapse: collapse;
}
.course-table th,
.course-table td {
  padding: 1rem;
  text-align: left;
  width: 20%;
  border: 1px solid #ccc;
}
.course-table th {
  font-weight: 800;
  font-family: 'GothicB';
}
.course-list-place {
  flex: 4;
  font-family: 'GothicB';
  display: flex;
  width: 100%;
  background-color: #80808021;
  justify-content: space-around;
  align-items: center;
  min-height: 14rem;
  margin-right: 1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .content {
    flex-direction: column;
  }

  .sidebar ul {
    text-align: center;
  }

  .sidebar ul li {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .my-courses-page h1 {
    font-size: 1.2rem;
    padding: 1rem 0;
  }

  .sidebar ul li {
    font-size: 0.85rem;
    padding: 0.5rem;
  }
}
</style>
